export default {
  "title": "Académie",
  "subtitle": "Camps, programmes et ateliers",
  "explore": "Explorez",
  "myBookings": "Mes réservations",
  "search": "Rechercher des programmes",
  "category": "Catégorie",
  "allCategories": "Toutes les catégories",
  "date": "Date",
  "details": "Détails du programme",
  "book": "Réserver",
  "waiting": "Rejoignez la liste d'attente",
  "participants": "Participants et dates",
  "summary": "Consentement et résumé",
  "payment": "Paiement",
  "confirm": "Confirmer la réservation",
  "continue": "Continuer",
  "back": "Retour",
  "consent": "J'accepte ces conditions pour chaque participant sélectionné et je confirme mon autorisation de réserver.",
  "total": "Total",
  "net": "Montant net",
  "tax": "Taxe",
  "free": "Gratuit",
  "member_account": "Charger mon compte membre",
  "cash": "Encaisse reçue par club",
  "card": "Paiement par carte",
  "cancel": "Annuler la réservation",
  "cancelReason": "Justification de l ' annulation",
  "confirmed": "Réservation confirmée",
  "held": "Lieu tenu — la participation n'est pas confirmée",
  "expired": "Date d ' expiration",
  "cancelled": "Annulé",
  "payment_attention": "Le paiement a besoin d'attention",
  "pending": "En attente",
  "paid": "Payé",
  "on_account": "Déposé à un compte membre",
  "none": "Aucun paiement requis",
  "refund_pending": "Remboursement en souffrance",
  "refund_failed": "Remboursement non remboursé",
  "refunded": "Remboursé",
  "terms": "Modalités",
  "eligibility": "Admissibilité",
  "prerequisite": "Préalable",
  "venue": "Lieu de réunion",
  "schedule": "Planning",
  "price": "Prix par participant",
  "availability": "Places disponibles",
  "noProgrammes": "Aucun programme ne correspond à vos filtres.",
  "noBookings": "Vous n'avez pas de réservation à l'Académie.",
  "loading": "Chargement de l'Académie...",
  "retry": "Réessayer",
  "error": "Incapable de compléter cette action. S'il vous plaît retry.",
  "unavailable": "Le paiement de la carte est indisponible jusqu’à ce que la configuration du fournisseur du club soit complète.",
  "reference": "Référence de réservation",
  "self": "Moi.",
  "dependant": "Personne à charge",
  "accept": "Offre acceptée",
  "decline": "Décline / laisser la liste d'attente",
  "offered": "Lieu offert",
  "waitingStatus": "Attendre",
  "accepted": "Acceptée",
  "declined": "Déclinée",
  "offering": "Offre",
  "configure": "Configuration de la réservation",
  "assisted": "Réservation assistée",
  "guardianReview": "Contrôle de l ' autorité de tutelle",
  "guardian": "Membre du tuteur",
  "payer": "Payer / acteur de réservation",
  "approve": "Autorisation du tuteur",
  "reason": "Justification de la révision",
  "save": "Publier la politique des membres",
  "description": "Description du membre",
  "image": "URL",
  "categoryLabel": "Catégorie",
  "termsLabel": "Conditions de consentement et d ' annulation",
  "visible": "Visible aux membres",
  "selectedDays": "Autoriser les jours sélectionnés",
  "accountCharge": "Autoriser la facturation du compte-membre",
  "cashEnabled": "Autoriser le règlement de caisse du club",
  "cardEnabled": "Autoriser le paiement de la carte configurée",
  "refundEnabled": "Remboursable avant la date limite d ' annulation",
  "cancellationHours": "Date limite d'annulation (heures avant le début)",
  "minAge": "Âge minimum (facultatif)",
  "maxAge": "Âge maximal (facultatif)",
  "taxCode": "Code fiscal ID",
  "mapping": "Chiffre de recettes",
  "bookingOpen": "Ouverture de la réservation",
  "bookingClose": "Fermetures de réservation",
  "history": "Historique des réservations",
  "refresh": "Actualiser",
  "selectOffering": "Sélectionnez une offre",
  "allOrNothing": "Les participants réservent et annulent en groupe. Quelques jours utilisent le prix du programme publié.",
  "startCheckout": "Ouvrir une caisse sécurisée",
  "resume": "Remboursement",
  "age_unknown": "Le club a besoin d'une date de naissance pour vérifier l'admissibilité.",
  "age_ineligible": "Ce participant se trouve à l'extérieur de la plage d'âge configurée.",
  "prerequisite_required": "Ce participant n'a pas respecté la condition préalable.",
  "guardian_authority_required": "L ' autorité de tutelle approuvée est requise.",
  "terms_changed": "Les modalités ont changé. Examiner le programme actuel avant de poursuivre.",
  "payer_authority_required": "Vous n'êtes pas autorisé à facturer ce payeur.",
  "cancellation_deadline_passed": "La date limite d'annulation est passée.",
  "occurrence_history_locked": "Cette session a commencé ou a des preuves de présence.",
  "offering_full": "Le programme est complet. Rejoignez la liste d'attente.",
  "already_enrolled": "Un participant sélectionné a déjà un endroit ou une liste d'attente.",
  "offering_not_ready": "Ce programme n'est plus réservable.",
  "booking_closed": "La fenêtre de réservation est fermée.",
  "member_account_required": "Un compte membre actif est requis.",
  "currency_unconfigured": "Le club doit configurer sa monnaie.",
  "tax_code_required": "Le club doit configurer un code fiscal actif.",
  "payment_method_unavailable": "Ce mode de paiement n'est pas disponible.",
  "idempotency_conflict": "Cette demande a changé. Commencez une nouvelle réservation.",
  "forbidden": "Vous n'avez pas la permission pour cette action.",
  "credit_limit_exceeded": "Cet achat dépasse la limite de crédit du compte membre.",
  "consent_required": "Acceptez les termes avant de confirmer.",
  "places_available": "Les places sont disponibles; réserver directement.",
  "offer_expired": "Cette offre a expiré.",
  "events": {
    "enrolment_confirmed": "Réservation de l'Académie confirmée",
    "enrolment_cancelled": "Réservation annulée",
    "waiting_joined": "Liste d'attente Joined Academy",
    "place_offered": "Lieu de l ' Académie",
    "place_offer_expired": "Offre d'académie expirée",
    "waiting_declined": "Liste d ' attente de l ' École de gauche",
    "waiting_attention": "Liste d ' attente de l ' Académie",
    "schedule_changed": "Calendrier de l'Académie changé",
    "attendance_recorded": "Participation à l ' Académie",
    "attendance_corrected": "Taux de fréquentation scolaire corrigés",
    "payment_attention": "Le paiement de l'académie a besoin d'attention",
    "refund_completed": "Remboursement de l ' Académie",
    "reminder": "Rappel de réservation à l'Académie"
  },
  "cancelOffering": "Annulez l'offre future et recouvrez les paiements",
  "nonMemberDependant": "Nom à charge non membre",
  "dateOfBirth": "Date de naissance",
  "createDependant": "Créer une personne à charge",
  "upcoming": "À venir",
  "past": "Passé",
  "attention": "Attention aux finances",
  "reconcile": "Reconcile fournisseur État",
  "cashRefund": "Confirmer le remboursement en espèces payé",
  "retryRefund": "Remboursement échoué",
  "cash_refund_confirmation_required": "Confirmez que le remboursement en espèces a été payé.",
  "refund_not_retryable": "Le fournisseur n'a pas confirmé une défaillance de remboursement terminal.",
  "accountCredited": "Crédit appliqué au compte membre",
  "staff_scope_required": "L'autorisation d'inscription des employés explicite est requise.",
  "nonMemberParticipant": "Non membres à charge",
  "personSearch": "Trouver un membre ou un employé",
  "employee": "Employé",
  "member": "Membre",
  "employeePayerReview": "Employé payeur",
  "employeePayerGuidance": "Les postes d'employés rémunérés exigent une autorisation révisée du payeur choisi. L'emploi ne permet jamais l'accès au compte.",
  "approvePayer": "Approuver l'autorisation explicite de payeur",
  "bookingActorMember": "Acteur de réservation / contact de membre",
  "payerMember": "Payant autorisé",
  "assistingStaff": "Aider le personnel : l'opérateur de club agréé vérifié.",
  "clubStaffActor": "Acteur du personnel du club (groupes salariés)",
  "noPayerFreeStaff": "Pas de payeur membre (groupe d'employés libres)",
  "selectedOccurrences": "Faits en cause",
  "clubLocalWindows": "Les fenêtres de réservation dans l'heure du club",
  "club_timezone_required": "Le club doit configurer un fuseau horaire IANA valide.",
  "invalid_local_time": "L'heure du club-local est invalide ou tombe dans un décalage d'économie de jour. Choisissez une autre fois.",
  "ambiguous_local_time": "Ce temps de club-local se produit deux fois lorsque les horloges changent. Choisissez un temps sans ambiguïté.",
  "invalid_booking_window": "Réservation close doit être après réservation ouverte.",
  "waitingManagement": "Listes d'attente et offres",
  "sequence": "FIFO séquence",
  "priority": "Priorité vérifiée",
  "offerDeadline": "Date limite d ' offre",
  "inspectWaiting": "Groupe d ' attente",
  "waitingDetail": "Détails du groupe d ' attente",
  "prepareOffer": "Offre de lieu d ' examen",
  "acceptOnBehalf": "Accepter l ' offre au nom",
  "declineOnBehalf": "Décline / congé en nom",
  "overridePriority": "Sauvegarder la priorité vérifiée"
};
